"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _partial = _interopRequireDefault(require("transmute/partial"));

var _ComponentWithPartials = _interopRequireDefault(require("UIComponents/mixins/ComponentWithPartials"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _color = require("MeetingsLib/utils/color");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var BUTTON_WIDTH = '102px';

var _default = (0, _createReactClass.default)({
  displayName: "StepButtonsFooter",
  mixins: [_ComponentWithPartials.default],
  propTypes: {
    submittingMeeting: _propTypes.default.bool,
    goToPreviousStep: _propTypes.default.func,
    goToNextStep: _propTypes.default.func,
    isLastStep: _propTypes.default.bool,
    canProceed: _propTypes.default.bool,
    tooltipTitle: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
    offline: _propTypes.default.bool,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired
  },
  getInitialState: function getInitialState() {
    return {
      forwardButtonHover: false,
      backButtonHover: false
    };
  },
  onMouseEnter: function onMouseEnter(newState) {
    this.setState(newState);
  },
  onMouseLeave: function onMouseLeave(newState) {
    this.setState(newState);
  },
  getForwardButtonKey: function getForwardButtonKey() {
    var lastStepKey = this.props.offline ? 'buttons.confirm.offline' : 'buttons.confirm.online';
    return this.props.isLastStep ? lastStepKey : 'buttons.next';
  },
  getForwardButtonVisibility: function getForwardButtonVisibility() {
    return this.props.goToNextStep ? 'visible' : 'hidden';
  },
  getProceedFunction: function getProceedFunction() {
    var _this$props = this.props,
        goToNextStep = _this$props.goToNextStep,
        goToPreviousStep = _this$props.goToPreviousStep;
    return goToNextStep ? this.partial(goToNextStep, goToPreviousStep) : null;
  },
  renderBackButton: function renderBackButton() {
    var _this$props2 = this.props,
        goToPreviousStep = _this$props2.goToPreviousStep,
        primaryColor = _this$props2.branding.primaryColor;

    if (!goToPreviousStep) {
      return null;
    }

    var brandingStyle = this.state.backButtonHover ? (0, _color.getSecondaryButtonHoverStyle)(primaryColor) : (0, _color.getSecondaryButtonStyle)(primaryColor);
    return _react.default.createElement(_UIButton.default, {
      style: Object.assign({
        minWidth: BUTTON_WIDTH,
        marginLeft: 0
      }, brandingStyle),
      onClick: goToPreviousStep,
      use: "secondary",
      "data-selenium-test": "back-button",
      onMouseEnter: (0, _partial.default)(this.onMouseEnter, {
        backButtonHover: true
      }),
      onMouseLeave: (0, _partial.default)(this.onMouseLeave, {
        backButtonHover: false
      })
    }, _react.default.createElement(_UIIcon.default, {
      name: "left"
    }), _react.default.createElement(_FormattedMessage.default, {
      message: "buttons.back"
    }));
  },
  renderForwardButton: function renderForwardButton() {
    var _this$props3 = this.props,
        submittingMeeting = _this$props3.submittingMeeting,
        canProceed = _this$props3.canProceed,
        tooltipTitle = _this$props3.tooltipTitle,
        primaryColor = _this$props3.branding.primaryColor;
    var visibility = this.getForwardButtonVisibility();
    var messageKey = this.getForwardButtonKey();
    var goToNextStep = this.getProceedFunction();
    var brandingStyle = this.state.forwardButtonHover ? (0, _color.getPrimaryButtonHoverStyle)(primaryColor) : (0, _color.getPrimaryButtonStyle)(primaryColor);

    var forwardButton = _react.default.createElement(_UILoadingButton.default, {
      style: Object.assign({
        minWidth: BUTTON_WIDTH,
        visibility: visibility
      }, brandingStyle),
      loading: submittingMeeting || false,
      onClick: goToNextStep,
      use: "primary",
      disabled: !canProceed,
      "data-selenium-test": "forward-button",
      onMouseEnter: (0, _partial.default)(this.onMouseEnter, {
        forwardButtonHover: true
      }),
      onMouseLeave: (0, _partial.default)(this.onMouseLeave, {
        forwardButtonHover: false
      })
    }, _react.default.createElement(_FormattedMessage.default, {
      message: messageKey
    }));

    if (tooltipTitle) {
      return _react.default.createElement(_UITooltip.default, {
        title: tooltipTitle,
        disabled: canProceed
      }, forwardButton);
    }

    return forwardButton;
  },
  render: function render() {
    return _react.default.createElement(_UIFlex.default, {
      direction: "row-reverse",
      className: "width-100",
      align: "end",
      justify: "between"
    }, this.renderForwardButton(), this.renderBackButton());
  }
});

exports.default = _default;
module.exports = exports.default;